<template>
  <v-card>
    <v-card-text
      class="text-xs-center headline secondary--text pb-0"
    >Inserindo nova forma de recebimento</v-card-text>
    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-container flex grid-list-lg>
            <v-form v-model="valid1" ref="firstForm">
              <v-layout justify-center row wrap>
                <v-flex
                  xs12
                  class="title primary--text text-xs-center"
                >Selecione uma das formas abaixo</v-flex>
                <v-flex xs12 md8>
                  <v-select
                    v-model="pagamento"
                    outline
                    placeholder="Clique para selecionar"
                    single-line
                    :items="tiposMaquineta"
                    item-text="descricao"
                    required
                    return-object
                    hide-details
                    :rules="[
                        v => !!v || ''
                    ]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-container flex grid-list-lg>
            <v-form v-model="valid2" ref="secondForm">
              <v-layout justify-center row wrap v-if="!loading">
                <v-flex
                  xs12
                  class="title primary--text text-xs-center"
                >Insira os dados para os seguintes campos</v-flex>
                <v-flex
                  xs11
                  class="secondary--text text-xs-center"
                  v-if="pagamento_secundario"
                >ATENÇÃO! Esta forma de pagamento é secundária, usada para recebimento pix e carteira digital pelo posto.</v-flex>
                <template v-for="(field, index) in fields">
                  <v-flex :key="index" xs12 md10 v-if="field === 'chave_pix'">
                  <v-select
                    label="Tipo de chave"
                    :items="[
                      'CNPJ',
                      'Número de Telefone',
                      'Chave Aleatória'
                    ]"
                    v-model="tipo_chave"
                  ></v-select>
                    <v-text-field
                      :label="field"
                      v-model="pagamento_model.formulario[field]"
                      hide-details
                      required
                      :mask="
                       tipo_chave === 'CNPJ' ? '##.###.###/####-##' : (tipo_chave === 'Número de Telefone' ? '(##) # ####-####' : '')
                      "
                      :rules="[
                        v => !!v || ''
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex :key="index" xs12 md10 v-else>
                    <v-text-field
                      :label="field"
                      v-model="pagamento_model.formulario[field]"
                      hide-details
                      required
                      :rules="[
                        v => !!v || ''
                      ]"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs6 class="text-xs-center">
                  <!-- <v-radio -->
                  <!-- <v-if="props.item.aceita_credito"> -->
                  <v-icon color="green" class="pr-1">check_circle</v-icon>
                  <span class="body-2 font-weight-regular">Aceita crédito</span>
                  <!-- </v-if> -->
                  <!-- </v-radio> -->
                  <!-- <td v-else class="text-xs-center">
                    <v-icon color="red" class="pr-1">check_circle</v-icon>
                    <span class="body-2 font-weight-regular">Aceita crédito</span>
                  </td>-->
                </v-flex>
                <v-flex xs6 class="text-xs-center">
                  <!-- <v-radio -->
                  <!-- <v-if="props.item.aceita_credito"> -->
                  <v-icon color="green" class="pr-1">check_circle</v-icon>
                  <span class="body-2 font-weight-regular">Aceita débito</span>
                  <!-- </v-if> -->
                  <!-- </v-radio> -->
                  <!-- <td v-else class="text-xs-center">
                    <v-icon color="red" class="pr-1">check_circle</v-icon>
                    <span class="body-2 font-weight-regular">Aceita crédito</span>
                  </td>-->
                </v-flex>
              </v-layout>
              <v-layout justify-center class="ma-4" v-else>
                <v-progress-circular
                  size="100"
                  color="info"
                  indeterminate
                ></v-progress-circular>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn block flat color="grey darken-3" @click="cancelar()">CANCELAR</v-btn>
      <v-btn
        block
        flat
        color="green"
        :disabled="disabledBtn"
        @click="continuar()"
        :loading="loading"
      >
        <template v-if="step === 1">CONTINUAR</template>
        <template v-else-if="step === 2">CONFIRMAR</template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { pagamentosExtra } from '@/api'

export default {
  data () {
    return {
      loading: false,
      tipo_chave: 'CNPJ',
      step: 1,
      valid1: false,
      valid2: false,
      fields: [],
      pagamentosExtra: [],
      pagamento: null,
      pagamento_secundario: null,
      pagamento_model: {
        posto: null,
        formulario: {},
        aceitar_credito: true,
        aceitar_debito: true,
        empresa: null,
        is_admin: false
      }
    }
  },
  computed: {
    disabledBtn () {
      switch (this.step) {
        case 1:
          return !this.pagamento
      }
      return false
    },
    tiposMaquineta () {
      return this.$store.getters.tiposMaquineta
    },
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  watch: {
    headers (val) {
      if (val) {
        pagamentosExtra
          .listar(val)
          .then(res => res.json())
          .then(json => (this.pagamentosExtra = json))
      }
    },
    pagamento (val) {
      if (val) {
        this.fields = val.nome_campos.split(',')
        this.pagamento_secundario = val.pagamento_secundario
      }
    }
  },
  methods: {
    continuar () {
      switch (this.step) {
        case 1:
          if (this.$refs.firstForm.validate()) {
            this.step = 2
          }
          break
        case 2:
          if (this.$refs.secondForm.validate()) {
            this.vincularPagamento()
          }
          break
      }
    },
    vincularPagamento () {
      this.loading = true
      if (this.tipo_chave === 'Número de Telefone') this.pagamento_model.formulario.chave_pix = `+55${this.pagamento_model.formulario.chave_pix}`
      pagamentosExtra
        .vincularPagamento(this.headers, this.pagamento.id_forma_pagamento, {
          ...this.pagamento_model,
          posto: this.posto.cnpj
        })
        .then(response => {
          this.loading = false
          if (response.ok) {
            this.$store.dispatch('carregarPagamentosExtra')
            this.$store.dispatch('carregarPagamentosSecundarios')
            this.$emit(
              'success',
              'Parabéns, a forma de pagamento foi vinculada com sucesso!'
            )
          } else {
            this.$emit(
              'error',
              'Infelizmente a forma de pagamento não pôde ser inserida!'
            )
          }
          this.cancelar()
        })
    },
    cancelar () {
      this.$refs.firstForm.reset()
      this.$refs.secondForm.reset()
      this.step = 1
      this.$emit('fechar')
    }
  }
}
</script>
